// ============================================
// FILE: /frontend/src/App.jsx
// UPDATED: Added UpgradeLimitModal globally
// ============================================

import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import { Toaster } from './hooks/useToast';
import AppRoutes from './routes/AppRoutes';
import './index.css';

// ⭐ NEW: Import modal globally (though it's used locally in CreateListingPage)
// This ensures the component is loaded and ready when needed
import UpgradeLimitModal from './components/modals/UpgradeLimitModal';

function App() {
  return (
    <Toaster>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </Toaster>
  );
}

export default App;